
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

export const useAdminAuthentication = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  
  const checkAuth = useCallback(() => {
    console.log('Checking admin authentication');
    const adminAuthenticated = localStorage.getItem('adminAuthenticated') === 'true';
    const authTimestamp = parseInt(localStorage.getItem('adminAuthTimestamp') || '0');
    const currentTime = Date.now();
    
    // Session expires after 4 hours
    const sessionExpired = currentTime - authTimestamp > 4 * 60 * 60 * 1000;
    
    if (!adminAuthenticated || sessionExpired) {
      if (sessionExpired) {
        toast({
          title: "Phiên đăng nhập hết hạn",
          description: "Vui lòng đăng nhập lại để tiếp tục",
          variant: "destructive"
        });
      }
      
      localStorage.removeItem('adminAuthenticated');
      localStorage.removeItem('adminAuthTimestamp');
      // Don't remove adminName to make re-login easier
      
      setTimeout(() => {
        navigate('/admin');
      }, 300);
      return false;
    }
    
    return true;
  }, [navigate, toast]);

  return { checkAuth };
};
